module.exports = __webpack_public_path__ + "img/deisy.17f678af.jpg";